import { render } from "./Chat.vue?vue&type=template&id=3c0c1a43"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=3c0c1a43&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__